import * as React from 'react';
import { useNavigate } from 'react-router-dom';

import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

import DishCard from './DishCardM.jsx';

import * as ApiCall from '../ApiCall.jsx';
import Button from '@mui/material/Button';

//just for testing the components
import chipsJPG from '../chips1.jpg';
import { Typography } from '@mui/material';


export default function CategoryCard({categoryInfo}) {

  let {
    name,
    id,
    imagePath,
    description,
    position,
  } = categoryInfo;

  const navigate = useNavigate();

  const pageURL = '/edit-menu/' + name;


  const [state, setState] = React.useState('loading');
  const [dishes, setDishes] = React.useState([]);
  const [refreshCounter, setRefreshCounter] = React.useState(0);

  const refreshParent = () => {
    // Update some state in the parent component to trigger a refresh
    setRefreshCounter(prevCounter => prevCounter + 1);
    setDishes([]);
  };

  function addDish(dish) {
    let copy = dishes;
    copy.push(dish);
    setDishes(copy);
  }


  React.useEffect(() => {
    setState("loading");
    ApiCall.get('/menu/dishes/'+position)
    .then((dishes) => {
      for (let i = 0; i < dishes.length; i++) {
        addDish(dishes[i]);
      }
      setState("success");
    })
    .catch((msg) => {alert("Failed to get dishes: "+msg)}); 
  }, [refreshCounter])

  function loadDishes() {

  }

  function handleAddDish() {
    navigate('edit-menu/add-dish', { state: { categoryInfo } });
  }

  return (
    <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls={name}
              id={id}
            >
              <Typography variant="h6" sx={{
                ml:"8px",
              }}>
                { name }
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
            <Button
              variant="contained"
              color="primary"
              onClick={handleAddDish}
              sx={{
                bgcolor:"black",
                ml:"8px",
                '&:hover': {
                  backgroundColor: '#777778',
                }
              }}
            >
              Add Dish
            </Button>
              { (state === "loading") &&
                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                  <CircularProgress />
                </Box>
              }
              { (state === "success") &&
                <List>
                  {
                    dishes.map((dish) => (
                      <ListItem disablePadding key={dish.id}>
                        <DishCard key={dish.id} dishInfo={dish} categoryName={name} categoryPosition={position} refreshParent={refreshParent}></DishCard>
                      </ListItem>
                    ))
                  }
                </List>
              }
            </AccordionDetails>
          </Accordion>
  )
}